<template>
  <v-container class="financial-page">
    <v-row class="reports-overview">
      <v-col cols="12">
        <span class="text-h4 pl-7 font-weight-medium">{{ lang.financial.reports.title }}</span>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="pa-0 ma-0">
        <div class="default-table salary-table" style="position: relative;">
          <v-row>
            <Search name="financial.reports">
              <Filters v-model="filters" />
            </Search>
          </v-row>
          <v-row>
            <v-col cols="12" lg="3" md="5" sm="12" xs="12" class="stats-col">
              <Info :filters="filters" @clearFilters="clearFilters" />
            </v-col>
            <v-col cols="12" lg="9" md="7" sm="12" xs="12" class="pa-0 ma-0">
              <v-simple-table
                fixed-header
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Título
                      </th>
                      <th class="text-left">
                        Lançamento
                      </th>
                      <th class="text-left">
                        Valor
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--  DESPESAS  -->
                    <tr>
                      <td>Despesas</td>
                      <td></td>
                      <td>R$ 750,00</td>
                    </tr>
                    <!--  DESPESAS > FIXAS   -->
                    <tr>
                      <td class="pl-8">Despesas Fixas</td>
                      <td></td>
                      <td>R$ 200,00</td>
                    </tr>
                    <!--   LISTAGEM DE CONTAS PERIÓDICAS  -->
                    <tr>
                      <td class="pl-12">Água</td>
                      <td></td>
                      <td>R$ 100,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Luz</td>
                      <td></td>
                      <td>R$ 100,00</td>
                    </tr>
                    <!--  DESPESAS > OUTRAS   -->
                    <tr>
                      <td class="pl-8">Outras</td>
                      <td></td>
                      <td>R$ 50,00</td>
                    </tr>
                    <!--   LISTAGEM DE OUTRAS DESPESAS  -->
                    <tr>
                      <td class="pl-12">Mercado</td>
                      <td></td>
                      <td>R$ 50,00</td>
                    </tr>
                    <!--  DESPESAS > ESTOQUE   -->
                    <tr>
                      <td class="pl-8">Reposição de Estoque</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <!--   LISTAGEM DE REPOSIÇÕES DE ESTOQUE  -->
                    <tr>
                      <td class="pl-12">Produto Y</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <!--  DESPESAS > FUNCIONÁRIOS   -->
                    <tr>
                      <td class="pl-8">Funcionários</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Salários</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Comissões</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Bonus</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Vales</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <tr>
                      <td class="pl-16">Vale Funcionários X</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <!--  RECEITAS  -->
                    <tr>
                      <td>Receitas</td>
                      <td></td>
                      <td>R$ 750,00</td>
                    </tr>
                    <!--  DESPESAS > FIXAS   -->
                    <tr>
                      <td class="pl-8">Vendas</td>
                      <td></td>
                      <td>R$ 200,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Cartão de Crédito</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Cartão de Débito</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Pix / Transferência</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                    <tr>
                      <td class="pl-12">Dinheiro</td>
                      <td></td>
                      <td>R$ 500,00</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '@/templates/global/Search'
import Filters from './templates/Filters'
import Info from './templates/Info'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import filters from '@/mixins/defaults/filters'
import list from '@/mixins/defaults/list_subpage'

export default {
  components: { Search, Filters, Info },
  mixins: [ appdata, utils, list ],
  data: () => ({
    filters: { ...filters.financial.reports }
  })
}
</script>

<style src="./styles/index.scss" lang="scss"></style>
